export enum ComplainType {
	None = 0,
	CutqualityLow = 1,
	Scratches = 2,
	MissingCuts = 3,
	WrongBending = 4,
	OutOfTolerance = 5,
	TransportDamage = 6,
	Missing = 7,
	Other = 8,
	WrongGrainDirection = 9,
	PowderCoating = 10,
	Weldline = 11,
	Features = 12,
	ZincCoating = 13,
	WrongOrMissingPressJoin = 14,
}
